'use client'

interface MessageBubbleProps {
  role: 'user' | 'assistant';
  content: string;
}

export default function MessageBubble({ role, content }: MessageBubbleProps) {
  const isUser = role === 'user';

  return (
    <div className={`flex ${isUser ? 'justify-end' : 'justify-start'} animate-message-fade-in`}>
      <div
        className={`max-w-[80%] px-4 py-3 text-sm leading-relaxed ${
          isUser
            ? 'bg-[#F5CC5C] text-[#103065] rounded-2xl rounded-br-md'
            : 'bg-[#f0f0f0] text-[#1E1E1E] rounded-2xl rounded-bl-md'
        }`}
      >
        {content}
      </div>
    </div>
  );
}
